import { CreateApiResponse, FetchApiResponse, FilterMetadata } from "redux/types";

export enum InstrumentBatchUploadTypes {
    FETCH_INSTRUMENT_BATCHES_UPLOAD = '@@auth/FETCH_INSTRUMENT_BATCHES_UPLOAD',
    FETCH_INSTRUMENT_BATCHES_UPLOAD_SUCCESS = '@@auth/FETCH_INSTRUMENT_BATCHES_UPLOAD_SUCCESS',
    FETCH_INSTRUMENT_BATCHES_UPLOAD_ERROR = '@@auth/FETCH_INSTRUMENT_BATCHES_UPLOAD_ERROR',

    FETCH_INSTRUMENT_BATCHE_UPLOAD_BY_ID = '@@auth/FETCH_INSTRUMENT_BATCHE_UPLOAD_BY_ID',
    FETCH_INSTRUMENT_BATCHE_UPLOAD_BY_ID_SUCCESS = '@@auth/FETCH_INSTRUMENT_BATCHE_UPLOAD_BY_ID_SUCCESS',
    FETCH_INSTRUMENT_BATCHE_UPLOAD_BY_ID_ERROR = '@@auth/FETCH_INSTRUMENT_BATCHE_UPLOAD_BY_ID_ERROR',

    FETCH_INSTRUMENTS_BY_BATCH_ID= '@@auth/FETCH_INSTRUMENTS_BY_BATCH_ID',
    FETCH_INSTRUMENTS_BY_BATCH_ID_SUCCESS = '@@auth/FETCH_INSTRUMENTS_BY_BATCH_ID_SUCCESS',
    FETCH_INSTRUMENTS_BY_BATCH_ID_ERROR = '@@auth/FETCH_INSTRUMENTS_BY_BATCH_ID_ERROR',

    // fetchInstrumentsByBatchId
    RESET = "@@transaction/instrumentBatchUpload/RESET",

    SET_INSTRUMENT_BATCH_UPLOAD_LIST_UI = "@@instrumentBatchUpload/SET_LIST_UI",
    RESET_INSTRUMENT_BATCH_UPLOAD_LIST_UI = "@@instrumentBatchUpload/RESET_LIST_UI"
}
export type InstrumentBatchUploadListUiState = {
  currentPage: number;
  searchFilter: Record<string, any>;
  sort: { field: string; order: boolean };
  isFilterApplied: boolean;
};


export type InstrumentBatchUploadActionDispatch = {
    type:
    | InstrumentBatchUploadTypes.FETCH_INSTRUMENT_BATCHES_UPLOAD
    | InstrumentBatchUploadTypes.FETCH_INSTRUMENT_BATCHE_UPLOAD_BY_ID
    | InstrumentBatchUploadTypes.FETCH_INSTRUMENTS_BY_BATCH_ID
    | InstrumentBatchUploadTypes.RESET;
    payload: any;
}

export type InstrumentBatchUploadReducerDispatch = {
    type:
    | InstrumentBatchUploadTypes.FETCH_INSTRUMENT_BATCHES_UPLOAD
    | InstrumentBatchUploadTypes.FETCH_INSTRUMENT_BATCHES_UPLOAD_SUCCESS
    | InstrumentBatchUploadTypes.FETCH_INSTRUMENT_BATCHES_UPLOAD_ERROR
    | InstrumentBatchUploadTypes.FETCH_INSTRUMENT_BATCHE_UPLOAD_BY_ID
    | InstrumentBatchUploadTypes.FETCH_INSTRUMENT_BATCHE_UPLOAD_BY_ID_SUCCESS
    | InstrumentBatchUploadTypes.FETCH_INSTRUMENT_BATCHE_UPLOAD_BY_ID_ERROR
    | InstrumentBatchUploadTypes.FETCH_INSTRUMENTS_BY_BATCH_ID
    | InstrumentBatchUploadTypes.FETCH_INSTRUMENTS_BY_BATCH_ID_SUCCESS
    | InstrumentBatchUploadTypes.FETCH_INSTRUMENTS_BY_BATCH_ID_ERROR
    | InstrumentBatchUploadTypes.RESET;
    payload: any;
}

export type InstrumentBatchUploadReduxState = {
    loading?: boolean;
    data?: FetchApiResponse<instrumnetBatchUpload>;
    error?: string | null;
}

export type InstrumentBatchUploadByIdReduxState = {
    loading?: boolean;
    data?: CreateApiResponse<instrumnetBatchUpload>;
    error?: string | null;
}

export type instrumnetBatchUpload={
    "id": string,
    "source": string,
    "status": string,
    "errorText": string,
    "updatedOn": Date
}
export type FetchUploadInstrumentBatchesRequest={
    payload: FilterMetadata,
    type: string;
}

export type FetchUploadInstrumentBatchByIdRequest = {
    payload: string;
    type: string;
};